import { combineReducers } from 'redux';
import canvaReducer from './canva/reducer';
import welcomeReducer from './welcome/reducer';

const reducers = combineReducers({
  canvaReducer,
  welcomeReducer
});

export default reducers;
